import React from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";
import "./successPage.style.css";
import "../app.css";
import { Link, useHistory } from "react-router-dom";
import { Button } from "react-bootstrap";
const SuccessPage = () => {

  const history = useHistory()

  const backToHome = () => {
    history.push('/')
  }

  return (
    <>
      <Header />
      <div className="success-page-layout">
        <div className="alphaBtnDiv">
          <Button disabled={true} className="alphaBtn">
            ALPHA
          </Button>{" "}
          <p>
            This is a new service
            </p>        </div>
        <Link className="back-to-hp" to="/">
          Back to homepage
        </Link>
        <h1 className="title">Welcome Aboard!</h1>
          <p className="description">
          Congratulations, you’re all signed up. Your checklist to income maximisation should arrive in your inbox soon.
            <br />
            <br />
            If we are able to connect you to an advisor, we’ll notify you by email as soon as we can.
            <br />
            <br />
            Thanks for signing up. Stay tuned.
          </p>
          <div className="success-btn-div">
          <Button onClick={backToHome} className="success-btn">Back to home</Button>
          </div>
      </div>

      <Footer />
    </>
  );
};

export default SuccessPage;
